import G6, { TreeGraph } from '@antv/g6/dist/g6.min';
import { fullOptionsMap, fullOptionsValueMap, operationTypeOptions, startPkgOptions } from '../options';
import { generateActionBar } from './common';
import {
  conditionAddButtonHeight,
  conditionContentPaddingY,
  conditionRowHeight,
  conditionRowInnerHeight,
  conditionTitleHeight,
  CustomNodeType,
  splitLineHeight,
  splitLineMargin,
  textareaHeight
} from './config';

function clickEvtfn(e) {
  const target = e.target;
  // 关联商品清单
  if (target.classList.contains('activity-conditions-link-btn')) {
    const index = Number(target.getAttribute('data-index'));
    const id = target.getAttribute('data-id');

    // @ts-ignore
    window.onActivityRuleLinkProducts(id, index);
  }
}

export const registerConditionShape = (treeGraph: TreeGraph) => {
  G6.registerNode(CustomNodeType.CONDITIONS, {
    draw: (cfg, group) => {
      const createConditionRowHtml = () => {
        const conditionData = (cfg!.jsonData as any)[cfg!.isPre ? 'conditions' : 'effectConditions'];
        const combineData = (cfg!.jsonData as any)[cfg!.isPre ? 'conditionsCombine' : 'effectConditionsCombine'];
        let conditionsHtml = ''; // 当前节点所有条件行html
        let combineColHtml = ''; // 当前节点组合列html

        conditionData.forEach((i, index) => {
          conditionsHtml += `
          <div style="display: flex;align-items: center;column-gap: 4px;height: ${conditionRowHeight}px">
            <select disabled data-id="${
              cfg!.id
            }" data-index="${index}" class="activity-conditions-operations-select condition-select" style="height: ${conditionRowInnerHeight}px;" placeholder="">
              ${operationTypeOptions.reduce(
                (t, c) =>
                  t + `<option value="${c.value}" ${i.optionType == c.value ? 'selected' : ''}>${c.label}</option>`,
                ''
              )}
            </select>
            <input disabled data-id="${cfg!.id}"  data-index="${index}" id="input_${
            i._uniqueId
          }" class="activity-conditions-startorder-input condition-number-input" type="number" value="${
            i.optionValue
          }" placeholder="数值" style="width: 50px;height: ${conditionRowInnerHeight}px;" />
            <select disabled data-id="${
              cfg!.id
            }"  data-index="${index}" class="activity-conditions-startpkg-select condition-select" style="height: ${conditionRowInnerHeight}px;" placeholder="包装">
            ${startPkgOptions.reduce(
              (t, c) =>
                t + `<option value="${c.value}" ${i.orderUnit == c.value ? 'selected' : ''}>${c.label}</option>`,
              ''
            )}
            </select>
            <span>起订，满</span>
            <input disabled data-id="${cfg!.id}"  data-index="${index}" id="full-unit_${
            i._uniqueId
          }" class="activity-conditions-fullnum-input condition-number-input" value="${
            i.fullNumber
          }" placeholder="数值" style="width: 50px;height: ${conditionRowInnerHeight}px;" />
            <select disabled data-id="${
              cfg!.id
            }"  data-index="${index}" class="activity-conditions-fullunit-select condition-select" style="width: 50px;height: ${conditionRowInnerHeight}px;" placeholder="">
                ${fullOptionsMap[i.optionType].reduce(
                  (t, c) =>
                    t +
                    `<option value="${c.value}" ${i[fullOptionsValueMap[i.optionType]] == c.value ? 'selected' : ''}>${
                      c.label
                    }</option>`,
                  ''
                )}
            </select>
            <div style="display: flex;align-items: center;height: 100;">
              ${
                !cfg!.isPre
                  ? ''
                  : `<span data-id="${
                      cfg!.id
                    }"  data-index="${index}" class="activity-conditions-link-btn iconfont icon-lianjie" style="margin-left:5px;font-size:18px;color:${
                      i.promotionItemStr ? '#d70a25' : '#333'
                    };cursor:pointer;"></span>`
              }
            </div>
          </div>
        `;
        });

        // 构建组合的行
        if (conditionData.length > 1) {
          combineData.groups.forEach((i, index) => {
            const h = i._uniqueIds.length * conditionRowHeight;
            const inH = h - conditionContentPaddingY * 2;
            combineColHtml += `
          <div style="display: flex;align-items: center;height: ${h}px"">
            <div style="display: flex;align-items: center;height: ${inH}px">
              <div style="display: flex;justify-content:center;width: 60px;height: 100%;background-color: ${
                i.type == 'and' ? 'var(--oio-button-primary-background)' : '#d7d7d7'
              };border-radius: 4px;">
                <select disabled data-id="${
                  cfg!.id
                }" data-index="${index}" class="activity-conditions-combine-btn condition-select" style="width: 100%;height: 100%;border:none;background-color:transparent;color: ${
              i.type == 'and' ? '#fff' : '#000'
            };text-align:center;" placeholder="">
                  <option value="and" ${i.type == 'and' ? 'selected' : ''}>且</option>
                  <option value="or" ${i.type == 'or' ? 'selected' : ''}>或</option>
                  ${i._uniqueIds.length > 1 ? '<option value="cancel">取消组</option>' : ''}
                </select>
              </div>
            </div>
          </div>
        `;
          });
        }

        // 当前节点最后一列
        const lastColHtml = `
        <div style="padding: ${conditionContentPaddingY}px 0;">
          <div style="display: flex;width: 50px;height: ${
            conditionData.length * conditionRowHeight - conditionContentPaddingY * 2
          }px;background-color: ${
          combineData.type == 'and' ? 'var(--oio-button-primary-background)' : '#d7d7d7'
        };border-radius: 4px;">
            <select disabled data-id="${
              cfg!.id
            }" class="activity-conditions-nodecombine-btn condition-select" style="width: 100%;height: 100%;border:none;background-color:transparent;color: ${
          combineData.type == 'and' ? '#fff' : '#000'
        };text-align:center;" placeholder="">
              <option value="and" ${combineData.type == 'and' ? 'selected' : ''}>且</option>
              <option value="or" ${combineData.type == 'or' ? 'selected' : ''}>或</option>
            </select>
          </div>
        </div>
      `;

        const res = `
        <div style="display: flex;column-gap: 4px;">
          <div>
            ${conditionsHtml}
          </div>
          <div>
            ${combineColHtml}
          </div>
          ${conditionData.length > 1 ? lastColHtml : ''}
        </div>
      `;

        return res;
      };

      // 只监听一次事件
      document.body.removeEventListener('click', clickEvtfn);
      document.body.addEventListener('click', clickEvtfn);

      return group!.addShape('dom', {
        attrs: {
          width: cfg!.size![0],
          height: cfg!.size![1],
          // 传入 DOM 的 html
          html: `
          <div>
            <div style="background-color: #f2f2f2;border-radius:4px;height: 100%;">
              <div style="background-color: ${
                cfg!.style!.titleBgColor
              }; color: #fff; font-size: 12px;text-align: center;border-radius:4px;height: ${conditionTitleHeight}px;line-height: ${conditionTitleHeight}px;">
              ${cfg!.title}
              </div>
              <div style="padding: ${conditionContentPaddingY}px ${conditionContentPaddingY * 2}px;">
                <div>
                  ${createConditionRowHtml()}
                </div>
                <div style="height: ${splitLineHeight}px;margin: ${splitLineMargin}px 0;background-color: ${
            cfg!.isPre ? '#d70a25' : 'var(--oio-button-primary-background)'
          };">
                </div>
                <textarea
                  disabled
                  class="activity-textarea"
                  data-id="${cfg!.id}"
                  placeholder="${cfg!.isPre ? '请输入必定提示文案' : '请输入活动提示文案'}" 
                  style="width: 100%;height: ${textareaHeight}px;border-radius: 4px;padding: 3px;resize: none;" 
                  rows="3">${cfg!.isPre ? cfg.jsonData.conditionDesc : cfg.jsonData.effectConditionDesc}</textarea>
              </div>
            </div>
            ${generateActionBar(cfg)}
          </div>
        `
        }
      });
    }
  });
};
